<script>
import { debounce } from 'lodash';
import { mapMutations, mapState } from 'vuex';

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState('analyzeDeforestationStore', ['filters'])
    },
    methods: {
        ...mapMutations('analyzeDeforestationStore', {
            setFilters: 'SET_FILTERS'
        }),
        search: debounce(function (e) {
            this.setFilters({ filtro: e.target.value });
        }, 500)
    }
};
</script>

<template>
    <div id="filters">
        <div id="input-wrap">
            <el-icon class="el-icon-search" />
            <input
                id="input-search"
                :placeholder="
                    $tc(
                        'analyze-deforestation.messages.filters_input_car_placeholder'
                    )
                "
                @input="search"
            />
        </div>
        <div id="options-container">
            <div class="options-wrap">
                <h3>
                    {{
                        $tc(
                            'analyze-deforestation.messages.filters_status_label'
                        )
                    }}
                </h3>
                <el-checkbox-group v-model="filters.situacoes">
                    <el-checkbox label="ENVIADO_PARA_ANALISE">
                        {{
                            $tc(
                                'analyze-deforestation.words.status_pending_analyze'
                            )
                        }}
                    </el-checkbox>
                    <el-checkbox class="ml-4" label="EM_ANALISE">
                        {{
                            $tc('analyze-deforestation.words.status_in_analyze')
                        }}
                    </el-checkbox>
                    <el-checkbox class="ml-4" label="ANALISE_FINALIZADA">
                        {{
                            $tc('analyze-deforestation.words.status_completed')
                        }}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
#filters {
    background-color: white;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
    gap: 20px;

    h3 {
        color: var(--primary);
        font-size: 16px;
        font-weight: 600;
        margin: 0 0 8px 0;
    }

    #options-container {
        display: flex;
        justify-content: space-between;
    }

    #input-wrap {
        background-color: white;
        border-radius: 8px;
        height: 39px;
        display: flex;
        align-items: center;
        padding: 0 12px;
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #dcdfe6;

        input {
            width: inherit;
            border: none;
            outline: none;
            color: var(--primary);
        }

        .el-icon-search {
            color: var(--primary);
            font-size: 16px;
            margin-right: 8px;
        }
    }
}
</style>
